import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-authenticated-user',
  template: require('./authenticated-user.component.html'),
  styles: [require('./authenticated-user.component.css')]
})
export class AuthenticatedUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/authenticated-user/authenticated-user.component.ts